import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Pagination } from '@mui/material';
import { Grid, Card, CardContent, CardHeader, Button, Typography, FormControl, TextField, Select, MenuItem, Dialog, DialogTitle, DialogActions, CardActions, Backdrop, CircularProgress, Box } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import moment from 'moment';
import { formatDate } from '../../helpers/custom';
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    customer_leads: any[];
    pageSize: number;
    rowCount: number;
    filter: any;
    fromDate?: string | null;
    toDate?: string | null;
    city: any;
    currentLead: any;
    newStatus: string;
    showLeadStatusChangeConfirmationDialog: boolean;
    currentPage:number
}

class CustomerLeads extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            customer_leads: [],
            pageSize: 10,
            rowCount: 0,
            filter: '',
            fromDate: formatDate(moment().startOf('week').format('YYYY-MM-DD'), 'Y-m-d'),
            toDate: formatDate(moment().endOf('week').format('YYYY-MM-DD'), 'Y-m-d'),
            city: '',
            currentLead: null,
            currentPage:0,
            newStatus: '',
            showLeadStatusChangeConfirmationDialog: false
        }
    }

    public componentDidMount(): void {
        this.fetchLeads();
    }

    public fetchLeads = (page: any = 0, limit: any = this.state.pageSize) => {
        this.setState({ showLoader: true });
        let data: any = {
            "filter": this.state.filter,
            "limit": limit,
            "page": page + 1
        }
        if (this.state.fromDate && this.state.toDate) {
            data['fromDate'] = this.state.fromDate;
            data['toDate'] = this.state.toDate;
        }
        axios.post('allLeads', data, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                this.setState({ showLoader: false });
                let list = response.data.data.data;
                let customer_leads = list.map((lead: any) => {
                    return {
                        "id": lead.id,
                        "name": lead.name,
                        "phone": lead.phone,
                        "email": lead.contact,
                        "address": lead.locality,
                        "city": lead.city,
                        "zipcode": lead.pincode,
                        "created_at": lead.created_at,
                        "status": lead.status,
                    }
                })
                this.setState({ customer_leads, rowCount: response.data.data.total })
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public handleUpdateLeadStatus = () => {
        this.setState({ showLoader: true });
        let body = {
            "lead_id": this.state.currentLead.id,
            "status": this.state.newStatus
        }
        axios.post('updateLeadStatus', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchLeads();
                this.setState({ showLoader: false, showLeadStatusChangeConfirmationDialog: false, currentLead: null, newStatus: "" });
            } else {
                this.setState({ showLoader: false, showLeadStatusChangeConfirmationDialog: false, currentLead: null, newStatus: "" });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false, showLeadStatusChangeConfirmationDialog: false, currentLead: null, newStatus: "" });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public downloadLeads = () => {
        this.setState({ showLoader: true });
        let data: any = { "filter": this.state.filter }
        if (this.state.fromDate && this.state.toDate) {
            data['fromDate'] = this.state.fromDate;
            data['toDate'] = this.state.toDate;
        }
        axios.post('downloadLeads', data).then((response: any) => {
            this.setState({ showLoader: false });
            let fileName = "New-Leads.csv";
            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const renderMaskedCell = (params: GridCellParams) => (
            <Box
                component="span"
                sx={isUatEnvironment ? {
                    filter: 'blur(4px)',
                    opacity: 0.5,
                    userSelect: 'none',
                } : undefined}
            >
                {params.value}
            </Box>
        );

        const columns: any = [
            {
                headerName: "Status",
                field: "status",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    // <Typography className={(params.row.status == 'Approved') ? 'statusTextSuccess' : ((params.row.status == 'Pending') ? 'statusTextWarning' : 'statusTextError')}>{params.row.status}</Typography>
                    <FormControl fullWidth size="small">
                        <Select
                            value={params.row.status}
                            onChange={(e: any) => this.setState({ showLeadStatusChangeConfirmationDialog: true, currentLead: params.row, newStatus: e.target.value })}
                            // displayEmpty
                            fullWidth={true}
                            inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value={'Pending'}>Pending</MenuItem>
                            <MenuItem value={'Approved'}>Approved</MenuItem>
                            <MenuItem value={'Rejected'}>Rejected</MenuItem>
                        </Select>
                    </FormControl>
                )
            },
            {
                headerName: "Name",
                field: "name",
                width: 200,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Mobile",
                field: "phone",
                width: 180,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Email",
                field: "email",
                width: 200,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Address",
                field: "address",
                width: 300,
                renderCell: renderMaskedCell
            },
            {
                headerName: "City",
                field: "city",
                width: 150,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Zipcode",
                field: "zipcode",
                width: 100,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Created At",
                field: "created_at",
                width: 170
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        icon={<EditOutlined />}
                        label="Edit"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />
                ],
                hide: true
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={5} xs={12}>
                                            <Typography>{t("Customer Leads")}</Typography>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.fetchLeads())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={6}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        renderInput={(props) => <TextField {...props} size="small" onKeyDown={(e: any) => e.preventDefault()} />}
                                                        label="From Date *"
                                                        views={['year', 'month', 'day']}
                                                        value={this.state.fromDate}
                                                        onChange={(newValue: any) => {
                                                            this.setState({ fromDate: formatDate(newValue, 'Y-m-d') }, () => this.fetchLeads());
                                                        }}
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={6}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        renderInput={(props) => <TextField {...props} size="small" onKeyDown={(e: any) => e.preventDefault()} />}
                                                        label="To Date *"
                                                        views={['year', 'month', 'day']}
                                                        value={this.state.toDate}
                                                        onChange={(newValue: any) => {
                                                            this.setState({ toDate: formatDate(newValue, 'Y-m-d') }, () => this.fetchLeads());
                                                        }}
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button size='large' fullWidth={true} variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.downloadLeads()}>{t("Download")}</Button>
                                    </CardActions>
                                }
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label="Customer Leads"
                                    columns={columns}
                                    rows={this.state.customer_leads}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchLeads(page)}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{ height: 500 }}
                                    pagination
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => {
                                                    this.setState({ currentPage: page - 1 }, () => this.fetchLeads(page - 1));
                                                }}
                                                
                                            />
                                        )
                                    }}
                                    // onRowClick={(params: GridRowParams) => {
                                    //     this.props.history.push('/neighbourhood/customer-leads/' + params.id)
                                    // }}
                                    paginationMode="server"
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.showLeadStatusChangeConfirmationDialog}
                    onClose={() => this.setState({ showLeadStatusChangeConfirmationDialog: false, currentLead: null, newStatus: "" })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Are you sure you want to change the status from <span className={(this.state.currentLead?.status == 'Approved') ? 'statusTextSuccess' : ((this.state.currentLead?.status == 'Pending') ? 'statusTextWarning' : 'statusTextError')}>{this.state.currentLead?.status}</span> to <span className={(this.state.newStatus == 'Approved') ? 'statusTextSuccess' : ((this.state.newStatus == 'Pending') ? 'statusTextWarning' : 'statusTextError')}>{this.state.newStatus}</span>?
                    </DialogTitle>
                    <DialogActions>
                        <Button size='small' className='customCloseButton' onClick={() => this.setState({ showLeadStatusChangeConfirmationDialog: false, currentLead: null, newStatus: "" })}>Close</Button>
                        <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.handleUpdateLeadStatus()} autoFocus>
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(CustomerLeads))
